exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#u3-template {\r\n  font-size: 16px;\n}\n.display-button {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\n}\n.ui {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: white;\n}", ""]);

// exports
